export enum GreetingKey {
  LADY = 'lady',
  MR = 'mr',
  MADAM = 'madam',
  NEUTRAL = 'neutral'
}
